export const HOTEL_MAPPING_EXPORT_FIELDS = [
  { key: 'hotel_id', label: '系统自增id', width: 14 },
  { key: 'inn_id', label: '系统 InnID', width: 18 },
  { key: 'target_type', label: '供应商', width: 14 },
  { key: 'hotel_name', label: '酒店名称', width: 28 },
  { key: 'hotel_address', label: '酒店地址', width: 42 },
  { key: 'jin_jiang_mapping', label: '锦江映射', width: 18 },
  { key: 'meituan_mapping', label: '美团映射', width: 18 },
  { key: 'ctrip_mapping', label: '携程映射', width: 18 },
  { key: 'eloon_mapping', label: '艺龙映射', width: 18 },
]

export function excelSafeValue(value) {
  if (value === null || value === undefined) return ''
  const text = String(value)
  return /^[=+\-@]/.test(text) ? "'" + text : text
}

export function selectedExportFields(keys) {
  const selected = new Set(keys || [])
  return HOTEL_MAPPING_EXPORT_FIELDS.filter(field => selected.has(field.key))
}

export function buildHotelMappingSheetRows(rows, keys, supplierName = value => value) {
  const fields = selectedExportFields(keys)
  return [
    fields.map(field => field.label),
    ...(rows || []).map(row => fields.map(field => {
      const value = field.key === 'target_type' ? supplierName(row[field.key]) : row[field.key]
      return excelSafeValue(value)
    })),
  ]
}
